<template>
  <div>
    <AuthorsHeader v-if="article.author" :blog-data="blog" />
    <DetailsArticle
      mode-post
      :article="article"
      entity-name="post"
      :url-share="urlShare"
      :show-button-save="false"
      :community-texts="community"
      :share-networks="shareNetworks"
      :content-text-share="contentTextShare"
    />
  </div>
</template>

<script setup>
import { STRUCTURED_DATA_TYPE } from '@/utils/enums';

const { t } = useI18n();
const route = useRoute();
const store = useStore();
const { createHeadSeo } = useHeadSeo();
const urlShare = process.env.APP_BASE_DOMAIN + route.fullPath;

const { data: article } = await useAsyncData(`blogPost_${route.params.slug}`, async () => {
  const res = await Promise.all([
    store.dispatch('strapi/getPostBySlug', {
      slug: route.params.slug,
      blog: route.params.blog
    }),
    store.dispatch('strapi/getCommunity')
  ]);
  return res[0];
});
if (article.value && !Object.entries(article.value)?.length) {
  throw createError({
    statusCode: 404,
    fatal: true
  });
}

const blog = computed(() => {
  const data = article.value;
  return { ...data, authors: [data.author], name: data.blog.name };
});
const shareNetworks = computed(() => store.getters['strapi/getByField']('common.social_sharing'));
const contentTextShare = computed(() =>
  store.getters['strapi/getByField']('common.social_sharing_modal')
);
const community = computed(() => {
  const { title_more_author: titleMoreAuthor, disclaimer } =
    store.getters['strapi/getByField']('community');
  return { titleMoreAuthor, disclaimer };
});

const { title: metaTitle, abstract, main_image: mainImage } = article.value;
const imgUrl = mainImage?.url ?? '';

createHeadSeo(metaTitle, abstract, imgUrl, article.value, STRUCTURED_DATA_TYPE.ARTICLE);
</script>
